import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, catchError, Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {BE_API_AUTH_URL} from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class ProgressService {
  private progressUpdated = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private authService: AuthService) {}

  // Observable that emits whenever progress is updated
  onProgressUpdate(): Observable<boolean> {
    return this.progressUpdated.asObservable();
  }

  // Trigger this method when progress changes
  notifyProgressUpdated(): void {
    this.progressUpdated.next(true);
  }

  getProgress(): Observable<any[]> {
    return this.http
      .get<any[]>(`${BE_API_AUTH_URL}/progress`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
